import * as Sentry from '@sentry/gatsby';
import { sentryConfigActivationFreeCover } from '@agria/utils/src/sentryConfigActivationFreeCover';

Sentry.init(sentryConfigActivationFreeCover);
